import { getHotelFilters } from "../../../utils/booking/hotel/transformHotelData";

export const updateHotelPayloadData = async (setBookingDetails: any, selectedChatData: any, startDate?: string) => {
  setBookingDetails((prevData: any) => {
    return {
      ...prevData,
      isDataModified: {
        ...prevData.isDataModified,
        hotel: true,
      },
      hotels: getHotelFilters(selectedChatData?.destinationList, startDate ?? selectedChatData?.start_date ?? "", selectedChatData?.hotel_name ?? ""),
    };
  });
};
